export const PHONE_NUMBER_MASK = '+1 (000) 000-0000';

/** E.164 US stored as `+1` + 10 digits (e.g. `+15551234567`). Used in MPA for SMS eligibility checks. */
export const US_PHONE_SERVER_LENGTH = 12;

/** Count of digits for a full US number including country code `1` (same as MPA SupportPad). */
export const PHONE_DIGITS_MIN_LENGTH = 11;
